<template>
    <span class="union-checkbox" :class="[{'checked':!isDisabled && isChecked},{'disabled':isDisabled}]" @click="handle">
        <span class="mark"></span>
        <span class="text">{{optionKey}}</span>
    </span>
</template>
<script>
    export default {
        props: {
            optionKey: { //标题文字
                type: String,
                default: ""
            },
            optionVal: { //值
                type: String|Number,
                default: ""
            },
            isChecked: { //是否选中
                type: Boolean,
                default: false
            },
            isDisabled: { //是否失效
                type: Boolean,
                default: false
            }
        },
        methods:{
            handle(){
                if(!this.isDisabled){
                    // this.isChecked = !this.isChecked;
                    this.$emit("handle",this.optionVal,!this.isChecked);
                }
            }
        }
    }
</script>
<style>
/* 复选拟态标记 - 勾选 */
.union-checkbox{
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 0.28rem;
    color: #231815;
    transition: all 0.3s ease;
}
.union-checkbox .mark{
    flex: 0 0 auto;
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.08rem;
    border: 1px solid #9b9a9d;
    border-radius: 0.03rem;
    position: relative;
}
.union-checkbox .text {
    flex: 1 1 auto;
}
.union-checkbox.checked{
    color: #f0861b;
    transition: all 0.3s ease;
}
.union-checkbox.checked .mark{
    border-color: #f0861b;
}
.union-checkbox.checked .mark:after{
    content: "";
    display: block;
    width: 0.2rem;
    height: 0.08rem;
    border-left: 1px solid #f0861b;
    border-bottom: 1px solid #f0861b;
    transform: skew(10deg,0deg) rotate(-45deg);
    position: absolute;
    left: 0.02rem;
    top: 0.04rem;
}
.union-checkbox.disabled{
    color: #9b9a9d;
    transition: all 0.3s ease;
}
.union-checkbox.disabled .mark{
    background-color: #dddddd;
    border-color: #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/checkbox.vue